// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progressButtonsChanged .v-btn--size-x-small[data-v-0e3bfccc]{max-height:10px !important;max-width:10px !important;margin:10px}.progressButtonsChanged .v-btn--icon[data-v-0e3bfccc]{color:#d1d8db}.progressButtonsChanged .v-btn--icon.v-btn--active[data-v-0e3bfccc]{color:#2a4a58}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
